import { activityAPI } from "../actions/activity";

export const trackActivity = async ({
    form,
    action,
    page,
    device = "web",
    network = "online",
    changes = [],
    rawData = [],
    isReverted = false,
    createdBy,
    createdAt = new Date().toISOString(),
    ids,
    metadata
}) => {
    const payload = {
        form,
        action,
        page,
        device,
        network,
        changes,
        rawData,
        isReverted,
        createdBy,
        createdAt,
        ids,
        metadata
    };

    await activityAPI.send(payload);
};
